import { EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Product } from '../../../core/models/product';
import chaining from '../../../core/helpers/chaining';
import { Image } from 'angular-modal-gallery';
import { minQuantity, stepping, unitPrice, upwardsQuantity } from '../../../core/helpers/prices';
import { canBuyProduct } from '../../../core/helpers/product';
import findTileFacets from '../../../core/helpers/tile-facet';
import { CombinedFacets } from '../../../facets/models/facet';
import * as FileSaver from 'file-saver';
var DetailsPageComponent = /** @class */ (function () {
    function DetailsPageComponent() {
        this.canDownloadImage = false;
        this.onAddCart = new EventEmitter();
        this.onFavoriteToggle = new EventEmitter();
        this.onClose = new EventEmitter();
        this.startQuantity = 0;
        this.showGallery = false;
        this.galleryMode = false;
        this.showMore = false;
    }
    DetailsPageComponent.prototype.ngOnChanges = function (changes) {
        this.getProductImage();
        this.isFavorite = this.getIsFavorite(this.product);
        this.getActualQuantity(this.cartProduct && this.cartProduct.quantity);
    };
    DetailsPageComponent.prototype.getProductImage = function () {
        if (this.product && this.product.assets && this.product.assets.imgs)
            this.productImage = new Image(+new Date(), {
                img: (this.product.assets.imgs
                    .find(function (img) { return img.type === 'zoom'; }) || {})
                    .src
            });
    };
    Object.defineProperty(DetailsPageComponent.prototype, "hasPrice", {
        get: function () {
            return !!(this.product && this.product.price);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "productFacets", {
        get: function () {
            return findTileFacets(chaining(this.detailsPageSettings, 'showFacets'), chaining(this.product, 'facets'), this.combinedFacets);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "cartProduct", {
        get: function () {
            if (this.product && this.product._id)
                return this.cartProducts[this.product._id];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "filteredStockInfo", {
        get: function () {
            if (chaining(this.product, 'stock')) {
                return this.product.stock.sort((function (a, b) {
                    if (a.date < b.date)
                        return -1;
                    if (a.date > b.date)
                        return 1;
                    return 0;
                }));
            }
            else
                return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "currentStockInfo", {
        get: function () {
            if (this.filteredStockInfo && this.filteredStockInfo.length > 0) {
                return this.filteredStockInfo.find(function (stockItem) { return stockItem.type === 'current'; });
            }
            return;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "futureStockInfos", {
        get: function () {
            if (this.filteredStockInfo && this.filteredStockInfo.length > 0) {
                return this.filteredStockInfo.filter(function (stockItem) { return stockItem.type === 'future'; });
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "totalInPurchaseOrderStock", {
        get: function () {
            if (this.filteredStockInfo && this.filteredStockInfo.length > 0) {
                return this.filteredStockInfo.find(function (stockItem) { return stockItem.type === 'totalInPurchaseOrders'; });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "totalFreeStock", {
        get: function () {
            if (this.filteredStockInfo && this.filteredStockInfo.length > 0) {
                return this.filteredStockInfo.find(function (stockItem) { return stockItem.type === 'freeStock'; });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "hasMoreInfoUrl", {
        get: function () {
            return !!this.product.moreInfoUrl;
        },
        enumerable: true,
        configurable: true
    });
    DetailsPageComponent.prototype.getActualQuantity = function (cartQuantity) {
        this.startQuantity = cartQuantity > 0
            ? cartQuantity
            : 0;
    };
    Object.defineProperty(DetailsPageComponent.prototype, "name", {
        get: function () {
            return chaining(this.product, 'name');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "code", {
        get: function () {
            return chaining(this.product, 'code');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "displayCode", {
        get: function () {
            return chaining(this.product, 'displayCode');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "prices", {
        get: function () {
            return chaining(this.product, 'price.prices');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "stepping", {
        get: function () {
            return stepping(this.product);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "actualStepping", {
        get: function () {
            return chaining(this.product, 'price.stepping');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "minQuantity", {
        get: function () {
            return minQuantity(this.product);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "actualQuantity", {
        get: function () {
            return upwardsQuantity(this.product, this.quantity || this.startQuantity);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "hasMultiplePrices", {
        get: function () {
            return chaining(this.prices, 'length') > 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "currentPrice", {
        get: function () {
            return unitPrice(this.product, this.actualQuantity || this.minQuantity);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "canBuy", {
        get: function () {
            return canBuyProduct(this.product, this.allowOutOfStockOrdering);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "showQuantityPickerAnimated", {
        get: function () {
            return (this.quantityPicker && this.quantityPicker.toLowerCase() === 'animated');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "quantityPickerRelative", {
        get: function () {
            return (this.quantityPicker && this.quantityPicker.toLowerCase()) === 'relative';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "showAttributes", {
        get: function () {
            return this.detailsPageSettings.showAttributes && this.detailsPageSettings.showAttributes.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "showFacets", {
        get: function () {
            return this.detailsPageSettings.showFacets && this.detailsPageSettings.showFacets.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailsPageComponent.prototype, "showAdditionalProductDetails", {
        get: function () {
            return this.showAttributes || this.showFacets;
        },
        enumerable: true,
        configurable: true
    });
    DetailsPageComponent.prototype.quantityChanged = function (event) {
        this.startQuantity = chaining(event, 'quantity');
        this.onAddCart.emit({
            product: chaining(this, 'product._id'),
            quantity: chaining(event, 'quantity')
        });
    };
    DetailsPageComponent.prototype.toggleFavorite = function (e) {
        e.stopPropagation();
        this.onFavoriteToggle.emit({
            isFavorite: this.isFavorite,
            product: this.product
        });
    };
    DetailsPageComponent.prototype.getIsFavorite = function (product) {
        return !!this.favoritesProducts.find(function (item) { return product && product.code === item.productCode; });
    };
    DetailsPageComponent.prototype.toggleShowMore = function () {
        this.showMore = !this.showMore;
    };
    DetailsPageComponent.prototype.addCart = function (event) {
        this.onAddCart.emit(event);
    };
    DetailsPageComponent.prototype.close = function () {
        this.onClose.emit();
    };
    DetailsPageComponent.prototype.toggleGallery = function () {
        this.showGallery = !this.showGallery;
    };
    DetailsPageComponent.prototype.toggleGalleryMode = function () {
        this.galleryMode = !this.galleryMode;
    };
    DetailsPageComponent.prototype.onImageError = function (url) {
        this.imgUrl = url;
    };
    DetailsPageComponent.prototype.downloadImage = function (url) {
        var fileName = url.substr(url.lastIndexOf('/') + 1) + '.jpg';
        FileSaver.saveAs(url, fileName);
    };
    return DetailsPageComponent;
}());
export { DetailsPageComponent };
